<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-briefcase</v-icon>
                    Employment
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonEmploymentDialog />
                <AddPersonEmploymentDialog :person-id="personId" />
            </v-toolbar>
            <v-data-table
                :headers="personEmploymentTableHeaders"
                :items="personEmploymentList"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">{{ props.item.ecsCompany.name }}</td>
                        <td class="text-xs-left">{{ props.item.job.name }}</td>
                        <td class="text-xs-left">{{ props.item.employmentType ? props.item.employmentType.name : "" }}</td>
                        <td class="text-xs-left">{{ props.item.weeklyHours }}</td>
                        <td class="text-xs-left">{{ props.item.startDate | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.endDate | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.isAllowedToil === true ? 'Yes' : 'No ' }}</td>
                        <td class="text-xs-left">{{ props.item.isAllowedExpenses === true ? 'Yes' : 'No ' }}</td>
                        <td class="text-xs-left">{{ props.item.comments }}</td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {UPDATE_PERSON_EMPLOYMENT} from "../../../../store/person_employment/actions"
    // import {FETCH_ECS_COMPANY_LIST} from "../../../../store/ecs_company/actions";
    import {LOAD_PERSON_EMPLOYMENT_TO_EDIT, TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG} from "../../../../store/person_employment/mutations.js";
    import {DELETE_PERSON_EMPLOYMENT, FETCH_PERSON_EMPLOYMENT_LIST} from "../../../../store/person_employment/actions.js";
    import EditTableFunctions from '../editTableFunctions';
    import AddPersonEmploymentDialog from "./AddPersonEmploymentDialog";
    import EditPersonEmploymentDialog from "./EditPersonEmploymentDialog";
    import {RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST} from "../../../../store/person_employment/mutations";

    export default {
        // TODO:: Trial periods

        name: "PersonEmploymentsTable",
        components: {EditPersonEmploymentDialog, AddPersonEmploymentDialog},
        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                idName: 'personEmploymentId',
                dialog: false,
                personEmploymentTableHeaders: [
                    {text: 'ECS Company', value: 'ecsCompanyId', sortable: false},
                    {text: 'Job Title', value: 'jobId'},
                    {text: 'Employment Type', value: 'employmentType'},
                    {text: 'Weekly Hours ', value: 'weeklyHours'},
                    {text: 'Start Date', value: 'startDate'},
                    {text: 'End Date', value: 'endDate'},
                    {text: 'TOIL', value: 'isAllowedToil'},
                    {text: 'Expenses', value: 'isAllowedExpenses'},
                    {text: 'Comments', value: 'comments'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {
            employmentTypeList() {
                return this.$store.getters.employmentTypeList;
            },
            jobList() {
                return this.$store.getters.jobList;
            },
            ...mapGetters(
            [
                "person",
                "getEcsCompanyNameById",
                "personEmploymentList",
                "employmentTypeList"
            ]
            ),

        },

        mounted() {
            if (this.personId) {
//                console.log(this.personId);
                //this.fetchEcsCompanyList();
                // this.fetchAllTableItems();
            }
        },

        methods: {
            resetTable() {
                this.$store.commit(RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST);
            },
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMPLOYMENT_LIST,
                updateTableItemRecord: UPDATE_PERSON_EMPLOYMENT,
                deleteTableItem: DELETE_PERSON_EMPLOYMENT,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_EMPLOYMENT_TO_EDIT,
                // resetEditItemToDefault: RESET_DEFAULT_EMPLOYMENT_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
</style>
